import React from 'react';
import { useRotaForm } from '../context/RotaContext';

const Step5Notifications = () => {
  const { formData, updateField } = useRotaForm();

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      {/* Component Title Summary */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold">5</div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Notifications (Optional)</h2>
          <p className="text-xs text-gray-500">Configure alert rules and write custom broadcast alerts for team members.</p>
        </div>
      </div>

      {/* Configuration Grid Panel */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Side: System Configurations */}
        <div className="space-y-3 flex flex-col justify-center">
          <label className="flex items-center gap-3 cursor-pointer group select-none">
            <input 
              type="checkbox" 
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
              checked={formData.notifyOnPublish}
              onChange={(e) => updateField('notifyOnPublish', e.target.checked)}
            />
            <span className="text-sm text-gray-700 group-hover:text-gray-900 transition">Notify staff when rota is published</span>
          </label>
          
          <label className="flex items-center gap-3 cursor-pointer group select-none">
            <input 
              type="checkbox" 
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
              checked={formData.sendReminder}
              onChange={(e) => updateField('sendReminder', e.target.checked)}
            />
            <span className="text-sm text-gray-700 group-hover:text-gray-900 transition">Send reminder 1 day before shift</span>
          </label>
          
          <label className="flex items-center gap-3 cursor-pointer group select-none">
            <input 
              type="checkbox" 
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
              checked={formData.includeChecksInNotification}
              onChange={(e) => updateField('includeChecksInNotification', e.target.checked)}
            />
            <span className="text-sm text-gray-700 group-hover:text-gray-900 transition">Include assigned checks in notification</span>
          </label>
        </div>

        {/* Right Side: Message Payload Textarea */}
        <div>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Broadcast Message</label>
          <textarea 
            rows={3} 
            maxLength={250}
            placeholder="e.g. Please check your assigned shifts, opening lists, and custom checks for next week..." 
            className="w-full text-xs p-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white placeholder-gray-400 text-gray-800 resize-none shadow-sm"
            value={formData.customMessage}
            onChange={(e) => updateField('customMessage', e.target.value)}
          />
          <div className="text-right text-[10px] font-medium text-gray-400 mt-1">
            {formData.customMessage.length} / 250 characters
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step5Notifications;
